import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";

const baseUrl = "/api/sif/drob/usoda";

export const getAnimalDestinyTypes = createAsyncThunk(
  "destiny/getAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        { page: 0, size: 1000 },
        null
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const animalDestinySlice = createSlice({
  name: "animalDestiny",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnimalDestinyTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAnimalDestinyTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.content || [];
      })
      .addCase(getAnimalDestinyTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default animalDestinySlice.reducer;
